module.exports = __webpack_public_path__ + "static/media/hand-receiving.499346d1.svg";